export interface IIndexIntradayResponse {
  date_time: string;
  price: number;
  variation_percentage: number;
  volume: number;
  variation: number;
}

export interface IIntradayDigitalResponse {
  date: string;
  price: number;
  percentageChange: number;
  volume: number;
  change: number;
}

export interface IIndexIntraday {
  time: string;
  value: number;
  percentageOfVariation: number;
  volume: number;
  variation: number;
}

export class IndexIntradayViewModel implements IIndexIntraday {
  static fromJSON(json: IIndexIntradayResponse): IndexIntradayViewModel {
    return new IndexIntradayViewModel(
      json.date_time,
      json.price,
      json.variation_percentage,
      json.volume,
      json.variation,
    );
  }

  static fromDigitalJSON(
    json: IIntradayDigitalResponse,
  ): IndexIntradayViewModel {
    return new IndexIntradayViewModel(
      json.date,
      json.price,
      json.percentageChange,
      json.volume,
      json.change,
    );
  }

  toJSON(): IIndexIntradayResponse {
    return Object.assign(
      {},
      {
        date_time: this.time,
        price: this.value,
        variation_percentage: this.percentageOfVariation,
        volume: this.volume,
        variation: this.variation,
      },
    );
  }

  constructor(
    public time: string,
    public value: number,
    public percentageOfVariation: number,
    public volume: number,
    public variation: number,
  ) {}
}
